import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Input from "../../../components/form/Input";
import NotificationSettingItem from "../../../components/NotificationSettingItem";
import { DashboardLayout } from "../../../components/organisms/Layout";

const GeneralSettings = () => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassword] = useState("abc123abc");
  const [newPassword, setNewPassword] = useState("abc123abc");
  const [confirmNewPassword, setConfirmNewPassword] = useState("abc123abc");

  // Toggles
  const [accountAlerts, setAccountAlerts] = useState(false);
  const [jobAlerts, setJobAlerts] = useState(false);

  useEffect(() => {
    document.title = "HeyHire Portal-General Settings";
  }, []);

  return (
    <DashboardLayout >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {t("general-settings.general-settings")}
            </h2>
            <p className="mt-1 text-sm text-gray-600">
              Manage your account settings and preferences
            </p>
          </div>
        </div>

        {/* Security Section */}
        <div className="bg-white">
          <h3 className="text-base font-semibold text-gray-900">
            {t("general-settings.security")}
          </h3>
          <p className="mt-1 text-sm text-gray-600">
            Update your password and security preferences
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
            name="currentPassword"
            type="password"
            icon="far fa-lock"
            label={t("general-settings.current-password")}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            
          />

          <Input
            name="newPassword"
            type="password"
            icon="far fa-lock"
            label={t("general-settings.new-password")}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            
          />

          <Input
            name="confirmNewPassword"
            type="password"
            icon="far fa-lock"
            label={t("general-settings.confirm-new-password")}
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            
          />
        </div>
      </div>

      {/* Notifications Section */}
        <div className="mt-8 bg-white">
          <h3 className="text-base font-semibold text-gray-900">
            {t("general-settings.notifications")}
          </h3>
          <p className="mt-1 text-sm text-gray-600">
            Choose what notifications you want to receive
          </p>

          <div className="space-y-6">
            <NotificationSettingItem
              title={t("general-settings.account-alerts")}
              description={t("general-settings.account-alerts-description")}
              value={accountAlerts}
              onChange={(e) => setAccountAlerts(e.target.checked)}
            />

            <NotificationSettingItem
              title={t("general-settings.message-alerts")}
              description={t("general-settings.message-alerts-description")}
              value={false}
              disabled={true}
            />

            <NotificationSettingItem
              title={t("general-settings.job-alerts")}
              description={t("general-settings.job-alerts-description")}
              value={jobAlerts}
              onChange={(e) => setJobAlerts(e.target.checked)}
            />

            <NotificationSettingItem
              title={t("general-settings.content-updates")}
              description={t("general-settings.content-updates-description")}
              value={false}
              disabled={true}
            />

            <NotificationSettingItem
              title={
                <span className="text-sm">
                  {t("general-settings.operational-email-toggle")}
                </span>
              }
              description={t("general-settings.operational-email-description")}
              value={false}
              disabled={true}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex justify-end gap-4">
        <button
          type="button"
          onClick={() => {}}
          className="rounded-lg px-4 py-2.5 text-sm font-semibold text-gray-900"
        >
          {t("common.clear")}
        </button>

        <button
          type="submit"
          onClick={() => {}}
          className="rounded-lg bg-primary-500 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center min-w-[100px]"
        >
          {t("common.save")}
        </button>
      </div>
    </div>
    </DashboardLayout>
  );
};

export default GeneralSettings;
